module.exports = __webpack_public_path__ + "img/addContact.36fd58ce.png";